<template>
  <nav-header></nav-header>
  <!-- main -->
  <main>
    <keep-alive>
      <router-view />
    </keep-alive>
  </main>
  <boom-footer></boom-footer>
</template>
<script>
import { reactive, onMounted, toRefs, nextTick } from 'vue'
import { useRouter } from 'vue-router'

import header from '@/components/Header.vue'
import footer from '@/components/Footer.vue'

export default {
  name: 'BasicLayout',
  components: {
    NavHeader: header,
    BoomFooter: footer
  },
  setup() {
    const router = useRouter()
    const state = reactive({
      isLayout: false,
    });
    return {
      ...toRefs(state),
    };
  }
}
</script>
<style scoped lang="scss">
    main{
        
    }
</style>
